export default "__VITE_ASSET__191e6703__"